/**
 * Converts an SVG string into a Base64-encoded string.
 *
 * @param svgString - The SVG string to be converted.
 * @returns A Base64-encoded string representing the SVG image.
 *
 * @remarks
 * This function properly handles Unicode characters (including Cyrillic, Hebrew, etc.)
 * by first encoding the string as UTF-8 bytes using TextEncoder, then converting to Base64.
 *
 * @example
 * ```typescript
 * const svg = '<svg xmlns="http://www.w3.org/2000/svg" width="100" height="100"><text x="10" y="50">שלום</text></svg>';
 * const base64String = svgStringToBase64Url(svg);
 * console.log(base64String); // Outputs: PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIj48Y2lyY2xlIGN4PSI1MCIgY3k9IjUwIiByPSI0MCIgZmlsbD0icmVkIiAvPjwvc3ZnPg==
 * ```
 */
export function svgStringToBase64Url(svgString: string): string {
  // Use TextEncoder to properly handle Unicode characters
  const encoder = new TextEncoder();
  const utf8Bytes = encoder.encode(svgString);

  // Convert UTF-8 bytes to binary string
  const binaryString = Array.from(utf8Bytes, byte => String.fromCharCode(byte)).join("");

  // Convert binary string to base64
  return btoa(binaryString);
}
